import { DELETE_CATEGORY } from '../../../constants';

const initialState = {
  data: null,
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DELETE_CATEGORY.LOAD:
      return {
        ...state,
        loading: true
      };
    case DELETE_CATEGORY.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case DELETE_CATEGORY.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
